import { create } from 'zustand'

/**
 * Singleton-style state for the message context menu. Prevents multiple
 * menus from rendering at once: when one message dispatches `open(id, …)`,
 * every other message item that was rendering its menu sees `openId` flip
 * away from its own id and unmounts. Per-component local state can't
 * coordinate that — siblings can't see each other.
 */
interface State {
  openId: string | null
  position: { x: number; y: number } | null
  open: (id: string, x: number, y: number) => void
  close: () => void
}

export const useMessageContextMenuStore = create<State>((set) => ({
  openId: null,
  position: null,
  open: (id, x, y) => set({ openId: id, position: { x, y } }),
  close: () => set({ openId: null, position: null }),
}))
